var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbsup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Thumbs up"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Hand"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5908 4.54821C16.4146 2.66492 18.215 1.83784 20.04 2.45639C21.9995 3.11965 22.8623 5.11204 21.7832 7.9177C21.1808 9.48407 20.4717 11.6365 20.4717 11.6365C20.4717 11.6365 19.821 12.4932 19.5334 12.7706C22.7371 14.4073 24.9323 17.7543 24.9323 21.6173C24.9323 22.6638 24.7712 23.6725 24.4726 24.6196L23.4766 31.775C23.4766 31.775 16.3047 31.6422 15.6572 31.6422C15.0098 31.6422 5.14844 32.0074 5.14844 21.6173C5.14844 15.3394 9.38184 13.8467 10.627 12.9488C11.8721 12.0509 13.1055 10.7099 13.5986 9.79368C14.4271 8.25427 14.9253 6.06973 15.5908 4.54821Z",
    fill: "url(#paint0_radial_956_8840)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5908 4.54821C16.4146 2.66492 18.215 1.83784 20.04 2.45639C21.9995 3.11965 22.8623 5.11204 21.7832 7.9177C21.1808 9.48407 20.4717 11.6365 20.4717 11.6365C20.4717 11.6365 19.821 12.4932 19.5334 12.7706C22.7371 14.4073 24.9323 17.7543 24.9323 21.6173C24.9323 22.6638 24.7712 23.6725 24.4726 24.6196L23.4766 31.775C23.4766 31.775 16.3047 31.6422 15.6572 31.6422C15.0098 31.6422 5.14844 32.0074 5.14844 21.6173C5.14844 15.3394 9.38184 13.8467 10.627 12.9488C11.8721 12.0509 13.1055 10.7099 13.5986 9.79368C14.4271 8.25427 14.9253 6.06973 15.5908 4.54821Z",
    fill: "url(#paint1_radial_956_8840)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5908 4.54821C16.4146 2.66492 18.215 1.83784 20.04 2.45639C21.9995 3.11965 22.8623 5.11204 21.7832 7.9177C21.1808 9.48407 20.4717 11.6365 20.4717 11.6365C20.4717 11.6365 19.821 12.4932 19.5334 12.7706C22.7371 14.4073 24.9323 17.7543 24.9323 21.6173C24.9323 22.6638 24.7712 23.6725 24.4726 24.6196L23.4766 31.775C23.4766 31.775 16.3047 31.6422 15.6572 31.6422C15.0098 31.6422 5.14844 32.0074 5.14844 21.6173C5.14844 15.3394 9.38184 13.8467 10.627 12.9488C11.8721 12.0509 13.1055 10.7099 13.5986 9.79368C14.4271 8.25427 14.9253 6.06973 15.5908 4.54821Z",
    fill: "url(#paint2_radial_956_8840)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5908 4.54821C16.4146 2.66492 18.215 1.83784 20.04 2.45639C21.9995 3.11965 22.8623 5.11204 21.7832 7.9177C21.1808 9.48407 20.4717 11.6365 20.4717 11.6365C20.4717 11.6365 19.821 12.4932 19.5334 12.7706C22.7371 14.4073 24.9323 17.7543 24.9323 21.6173C24.9323 22.6638 24.7712 23.6725 24.4726 24.6196L23.4766 31.775C23.4766 31.775 16.3047 31.6422 15.6572 31.6422C15.0098 31.6422 5.14844 32.0074 5.14844 21.6173C5.14844 15.3394 9.38184 13.8467 10.627 12.9488C11.8721 12.0509 13.1055 10.7099 13.5986 9.79368C14.4271 8.25427 14.9253 6.06973 15.5908 4.54821Z",
    fill: "url(#paint3_linear_956_8840)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5908 4.54821C16.4146 2.66492 18.215 1.83784 20.04 2.45639C21.9995 3.11965 22.8623 5.11204 21.7832 7.9177C21.1808 9.48407 20.4717 11.6365 20.4717 11.6365C20.4717 11.6365 19.821 12.4932 19.5334 12.7706C22.7371 14.4073 24.9323 17.7543 24.9323 21.6173C24.9323 22.6638 24.7712 23.6725 24.4726 24.6196L23.4766 31.775C23.4766 31.775 16.3047 31.6422 15.6572 31.6422C15.0098 31.6422 5.14844 32.0074 5.14844 21.6173C5.14844 15.3394 9.38184 13.8467 10.627 12.9488C11.8721 12.0509 13.1055 10.7099 13.5986 9.79368C14.4271 8.25427 14.9253 6.06973 15.5908 4.54821Z",
    fill: "url(#paint4_radial_956_8840)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5908 4.54821C16.4146 2.66492 18.215 1.83784 20.04 2.45639C21.9995 3.11965 22.8623 5.11204 21.7832 7.9177C21.1808 9.48407 20.4717 11.6365 20.4717 11.6365C20.4717 11.6365 19.821 12.4932 19.5334 12.7706C22.7371 14.4073 24.9323 17.7543 24.9323 21.6173C24.9323 22.6638 24.7712 23.6725 24.4726 24.6196L23.4766 31.775C23.4766 31.775 16.3047 31.6422 15.6572 31.6422C15.0098 31.6422 5.14844 32.0074 5.14844 21.6173C5.14844 15.3394 9.38184 13.8467 10.627 12.9488C11.8721 12.0509 13.1055 10.7099 13.5986 9.79368C14.4271 8.25427 14.9253 6.06973 15.5908 4.54821Z",
    fill: "url(#paint5_radial_956_8840)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5908 4.54821C16.4146 2.66492 18.215 1.83784 20.04 2.45639C21.9995 3.11965 22.8623 5.11204 21.7832 7.9177C21.1808 9.48407 20.4717 11.6365 20.4717 11.6365C20.4717 11.6365 19.821 12.4932 19.5334 12.7706C22.7371 14.4073 24.9323 17.7543 24.9323 21.6173C24.9323 22.6638 24.7712 23.6725 24.4726 24.6196L23.4766 31.775C23.4766 31.775 16.3047 31.6422 15.6572 31.6422C15.0098 31.6422 5.14844 32.0074 5.14844 21.6173C5.14844 15.3394 9.38184 13.8467 10.627 12.9488C11.8721 12.0509 13.1055 10.7099 13.5986 9.79368C14.4271 8.25427 14.9253 6.06973 15.5908 4.54821Z",
    fill: "url(#paint6_radial_956_8840)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5908 4.54821C16.4146 2.66492 18.215 1.83784 20.04 2.45639C21.9995 3.11965 22.8623 5.11204 21.7832 7.9177C21.1808 9.48407 20.4717 11.6365 20.4717 11.6365C20.4717 11.6365 19.821 12.4932 19.5334 12.7706C22.7371 14.4073 24.9323 17.7543 24.9323 21.6173C24.9323 22.6638 24.7712 23.6725 24.4726 24.6196L23.4766 31.775C23.4766 31.775 16.3047 31.6422 15.6572 31.6422C15.0098 31.6422 5.14844 32.0074 5.14844 21.6173C5.14844 15.3394 9.38184 13.8467 10.627 12.9488C11.8721 12.0509 13.1055 10.7099 13.5986 9.79368C14.4271 8.25427 14.9253 6.06973 15.5908 4.54821Z",
    fill: "url(#paint7_radial_956_8840)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5908 4.54821C16.4146 2.66492 18.215 1.83784 20.04 2.45639C21.9995 3.11965 22.8623 5.11204 21.7832 7.9177C21.1808 9.48407 20.4717 11.6365 20.4717 11.6365C20.4717 11.6365 19.821 12.4932 19.5334 12.7706C22.7371 14.4073 24.9323 17.7543 24.9323 21.6173C24.9323 22.6638 24.7712 23.6725 24.4726 24.6196L23.4766 31.775C23.4766 31.775 16.3047 31.6422 15.6572 31.6422C15.0098 31.6422 5.14844 32.0074 5.14844 21.6173C5.14844 15.3394 9.38184 13.8467 10.627 12.9488C11.8721 12.0509 13.1055 10.7099 13.5986 9.79368C14.4271 8.25427 14.9253 6.06973 15.5908 4.54821Z",
    fill: "url(#paint8_radial_956_8840)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Thumb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5889 4.55212C16.4126 2.66883 18.213 1.84175 20.0381 2.4603C21.9975 3.12356 22.8604 5.11594 21.7812 7.92161C21.1788 9.48797 20.4697 11.6404 20.4697 11.6404L19.5315 12.7745C14.9414 15.1095 10.625 12.9527 10.625 12.9527C11.8701 12.0548 13.1036 10.7138 13.5967 9.79758C14.4252 8.25817 14.9233 6.07363 15.5889 4.55212Z",
    fill: "#FDB026"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5889 4.55212C16.4126 2.66883 18.213 1.84175 20.0381 2.4603C21.9975 3.12356 22.8604 5.11594 21.7812 7.92161C21.1788 9.48797 20.4697 11.6404 20.4697 11.6404L19.5315 12.7745C14.9414 15.1095 10.625 12.9527 10.625 12.9527C11.8701 12.0548 13.1036 10.7138 13.5967 9.79758C14.4252 8.25817 14.9233 6.07363 15.5889 4.55212Z",
    fill: "url(#paint9_radial_956_8840)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5889 4.55212C16.4126 2.66883 18.213 1.84175 20.0381 2.4603C21.9975 3.12356 22.8604 5.11594 21.7812 7.92161C21.1788 9.48797 20.4697 11.6404 20.4697 11.6404L19.5315 12.7745C14.9414 15.1095 10.625 12.9527 10.625 12.9527C11.8701 12.0548 13.1036 10.7138 13.5967 9.79758C14.4252 8.25817 14.9233 6.07363 15.5889 4.55212Z",
    fill: "url(#paint10_radial_956_8840)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5889 4.55212C16.4126 2.66883 18.213 1.84175 20.0381 2.4603C21.9975 3.12356 22.8604 5.11594 21.7812 7.92161C21.1788 9.48797 20.4697 11.6404 20.4697 11.6404L19.5315 12.7745C14.9414 15.1095 10.625 12.9527 10.625 12.9527C11.8701 12.0548 13.1036 10.7138 13.5967 9.79758C14.4252 8.25817 14.9233 6.07363 15.5889 4.55212Z",
    fill: "url(#paint11_radial_956_8840)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5889 4.55212C16.4126 2.66883 18.213 1.84175 20.0381 2.4603C21.9975 3.12356 22.8604 5.11594 21.7812 7.92161C21.1788 9.48797 20.4697 11.6404 20.4697 11.6404L19.5315 12.7745C14.9414 15.1095 10.625 12.9527 10.625 12.9527C11.8701 12.0548 13.1036 10.7138 13.5967 9.79758C14.4252 8.25817 14.9233 6.07363 15.5889 4.55212Z",
    fill: "url(#paint12_radial_956_8840)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5889 4.55212C16.4126 2.66883 18.213 1.84175 20.0381 2.4603C21.9975 3.12356 22.8604 5.11594 21.7812 7.92161C21.1788 9.48797 20.4697 11.6404 20.4697 11.6404L19.5315 12.7745C14.9414 15.1095 10.625 12.9527 10.625 12.9527C11.8701 12.0548 13.1036 10.7138 13.5967 9.79758C14.4252 8.25817 14.9233 6.07363 15.5889 4.55212Z",
    fill: "url(#paint13_radial_956_8840)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Index"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.4531,
    y: 11.6016,
    width: 6.18397,
    height: 9.60872,
    rx: 3.09198,
    transform: "rotate(90 27.4531 11.6016)",
    fill: "url(#paint14_radial_956_8840)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.4531,
    y: 11.6016,
    width: 6.18397,
    height: 9.60872,
    rx: 3.09198,
    transform: "rotate(90 27.4531 11.6016)",
    fill: "url(#paint15_linear_956_8840)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.4531,
    y: 11.6016,
    width: 6.18397,
    height: 9.60872,
    rx: 3.09198,
    transform: "rotate(90 27.4531 11.6016)",
    fill: "url(#paint16_radial_956_8840)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Little"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.6953,
    y: 25.7969,
    width: 6.01758,
    height: 7.63672,
    rx: 3.00879,
    transform: "rotate(90 26.6953 25.7969)",
    fill: "url(#paint17_radial_956_8840)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.6953,
    y: 25.7969,
    width: 6.01758,
    height: 7.63672,
    rx: 3.00879,
    transform: "rotate(90 26.6953 25.7969)",
    fill: "url(#paint18_radial_956_8840)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.6953,
    y: 25.7969,
    width: 6.01758,
    height: 7.63672,
    rx: 3.00879,
    transform: "rotate(90 26.6953 25.7969)",
    fill: "url(#paint19_radial_956_8840)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.6953,
    y: 25.7969,
    width: 6.01758,
    height: 7.63672,
    rx: 3.00879,
    transform: "rotate(90 26.6953 25.7969)",
    fill: "url(#paint20_radial_956_8840)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.6953,
    y: 25.7969,
    width: 6.01758,
    height: 7.63672,
    rx: 3.00879,
    transform: "rotate(90 26.6953 25.7969)",
    fill: "url(#paint21_radial_956_8840)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.6953,
    y: 25.7969,
    width: 6.01758,
    height: 7.63672,
    rx: 3.00879,
    transform: "rotate(90 26.6953 25.7969)",
    fill: "url(#paint22_radial_956_8840)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.6953,
    y: 25.7969,
    width: 6.01758,
    height: 7.63672,
    rx: 3.00879,
    transform: "rotate(90 26.6953 25.7969)",
    fill: "url(#paint23_radial_956_8840)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.6953,
    y: 25.7969,
    width: 6.01758,
    height: 7.63672,
    rx: 3.00879,
    transform: "rotate(90 26.6953 25.7969)",
    fill: "url(#paint24_radial_956_8840)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ring"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.1055,
    y: 21.4844,
    width: 6.05957,
    height: 10.2603,
    rx: 3.02979,
    transform: "rotate(90 28.1055 21.4844)",
    fill: "url(#paint25_radial_956_8840)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.1055,
    y: 21.4844,
    width: 6.05957,
    height: 10.2603,
    rx: 3.02979,
    transform: "rotate(90 28.1055 21.4844)",
    fill: "url(#paint26_radial_956_8840)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.1055,
    y: 21.4844,
    width: 6.05957,
    height: 10.2603,
    rx: 3.02979,
    transform: "rotate(90 28.1055 21.4844)",
    fill: "url(#paint27_radial_956_8840)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.1055,
    y: 21.4844,
    width: 6.05957,
    height: 10.2603,
    rx: 3.02979,
    transform: "rotate(90 28.1055 21.4844)",
    fill: "url(#paint28_radial_956_8840)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Middle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.5938,
    y: 16.7344,
    width: 5.59473,
    height: 11.6086,
    rx: 2.79736,
    transform: "rotate(90 28.5938 16.7344)",
    fill: "url(#paint29_radial_956_8840)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.5938,
    y: 16.7344,
    width: 5.59473,
    height: 11.6086,
    rx: 2.79736,
    transform: "rotate(90 28.5938 16.7344)",
    fill: "url(#paint30_radial_956_8840)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_956_8840",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.7129 22.4435) rotate(-180) scale(26.2969 23.8398)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCA148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507576,
    stopColor: "#FFC32B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.689394,
    stopColor: "#ECA332"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8A528"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_956_8840",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.0409 21.4474) rotate(75.9588) scale(23.4104 23.7191)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.345735,
    stopColor: "#D5A75B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427604,
    stopColor: "#D5A75B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_956_8840",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.123 24.3029) rotate(85.3196) scale(11.3935 8.13383)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.529843,
    stopColor: "#F59842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F59842",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_956_8840",
    x1: 12.0879,
    y1: 32.2716,
    x2: 12.0879,
    y2: 20.4513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB7D5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA746",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_956_8840",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.0566 16.5333) rotate(-1.52076) scale(7.50655 5.64373)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.193422,
    stopColor: "#C36F14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.643579,
    stopColor: "#F59842",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_956_8840",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.127 20.9161) rotate(-6.14661) scale(8.68273 8.05296)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.215957,
    stopColor: "#C36F14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.701321,
    stopColor: "#F59842",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_956_8840",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.0566 24.5353) rotate(0.753843) scale(7.57097 10.1374)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.287032,
    stopColor: "#C36F14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.569673,
    stopColor: "#F59842",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_956_8840",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.3223 28.3536) rotate(-15.3885) scale(7.50743 8.03726)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.174171,
    stopColor: "#C56736"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.643579,
    stopColor: "#F59842",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_956_8840",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.7949 12.6154) rotate(64.5367) scale(1.54457 3.56593)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4792,
    stopColor: "#FFC054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC054",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_956_8840",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.5859 5.71301) rotate(114.164) scale(19.1422 6.39202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.164912,
    stopColor: "#FFCF47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.748557,
    stopColor: "#FFB126"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_956_8840",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.6172 1.59583) rotate(100.798) scale(13.115 4.21596)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.801269,
    stopColor: "#D5A75B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5A75B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_956_8840",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.9453 13.5822) rotate(124.242) scale(4.77964 1.92528)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.444359,
    stopColor: "#FFC22B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC22C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_956_8840",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.7227 6.6427) rotate(109.612) scale(6.13315 2.51509)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCE47",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_956_8840",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.3867 4.84973) rotate(83.211) scale(2.80876 2.44236)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF067"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF067",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_956_8840",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.7981 13.6892) rotate(90) scale(7.52051 4.84004)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0706402,
    stopColor: "#FFEF66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785872,
    stopColor: "#FEB426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5A340"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_956_8840",
    x1: 32.8528,
    y1: 16.0134,
    x2: 31.5911,
    y2: 16.0134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4A009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.684211,
    stopColor: "#F4A009",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_956_8840",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.6372 20.0642) rotate(124.356) scale(3.86109 2.2032)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.336779,
    stopColor: "#D98320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D98320",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_956_8840",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.0195 27.0586) rotate(89.2116) scale(7.23897 5.70416)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.683436,
    stopColor: "#FFAE4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59228"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_956_8840",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.502 31.9062) rotate(-97.1135) scale(6.37184 2.55335)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F29545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F29545",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_956_8840",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.2969 41.0371) rotate(-82.8317) scale(21.819 2.22182)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.645549,
    stopColor: "#EE970B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.700392,
    stopColor: "#EE970B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_956_8840",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.0156 27.5898) rotate(-90) scale(10.5918 8.09097)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354232,
    stopColor: "#D17D15",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72369,
    stopColor: "#BE691D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_956_8840",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.459 32.5039) rotate(77.3998) scale(5.78383 2.47098)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF7916"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF7916",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_956_8840",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.9082 33.4336) rotate(-52.125) scale(4.16431 1.35995)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D78867"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D78867",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_956_8840",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.0859 29.2168) rotate(-176.915) scale(5.55297 8.08168)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.507317,
    stopColor: "#DE89A6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.658154,
    stopColor: "#DA849D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.680473,
    stopColor: "#E99DA8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_956_8840",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.9785 33.7988) rotate(-28.3008) scale(3.43167 2.70408)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6875C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6875C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_956_8840",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.4033 23.7136) rotate(90) scale(8.03051 4.74267)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0706402,
    stopColor: "#FFEA68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785872,
    stopColor: "#FEB426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5A340"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_956_8840",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.5762 30.0674) rotate(-91.7184) scale(13.2872 4.05895)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE934A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE934A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_956_8840",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.9199 32.3584) rotate(-53.5194) scale(5.86381 1.79126)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D77B5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA7D63",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_956_8840",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.6367 31.7441) rotate(-89.9187) scale(23.3916 1.02901)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.39245,
    stopColor: "#EE970B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.858036,
    stopColor: "#FFB610",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_956_8840",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.7153 19.2565) rotate(90) scale(9.08579 4.37885)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0706402,
    stopColor: "#FFEF66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785872,
    stopColor: "#FEB426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5A340"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_956_8840",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.6367 25.8694) rotate(-90) scale(17.6641 3.12109)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA84A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F29545",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsup);
export default __webpack_public_path__ + "static/media/Thumbs up.e9bbd2f58862ffec68c0cc51ff4767b0.svg";
export { ForwardRef as ReactComponent };